import { getJSON } from 'wix-fetch'
import { warmupData, rendering } from 'wix-window-frontend'
import { session } from 'wix-storage-frontend'
import wixLocationFrontend from 'wix-location-frontend'

const handleUserMenu = async () => {
    // const userDetails = await wrapWithWarmupData('userData', getUserData)
    if (rendering.env === 'browser') {
        const $desktopLogInMSB = $w('#desktopLogInMSB')
        const userDetails = await wrapWithSessionStorage('userData', getUserData)
        console.log('userDetails', userDetails)
        const { sucess, profileImage, first, last } = userDetails
        if (sucess) {
            $w('#profileImage').src = profileImage
            $w('#userNameButton').label = `${first} ${last}`
            $desktopLogInMSB.changeState('desktopLoggedIn')
        } else {
            $desktopLogInMSB.changeState('desktopLoggedOut')
        }
        $desktopLogInMSB.expand()

        $w('#userNameButton').onClick(() => {
            const $userMenu = $w('#userMenu')
            if ($userMenu.collapsed) {
                $userMenu.expand();
            } else {
                $userMenu.collapse();
            }
        })
    }

    $w('#mobileSignUpButton').link = getSignInLink(false)
    $w('#desktopSignOutButton').link = getSignOuLink()
}

const wrapWithWarmupData = async (key, callback) => {
    if (rendering.env === 'backend') {
        const data = await callback()
        warmupData.set(key, data)
        return data
    } else {
        const data = warmupData.get(key)
        return data || await callback()
    }
}

const wrapWithSessionStorage = async (key, callback) => {
    const dataFromStorage = session.getItem(key)
    if (dataFromStorage) return JSON.parse(dataFromStorage)

    const data = await callback()
    session.setItem(key, JSON.stringify(data))
    return data
}

const API_URL = 'https://www.wix.com/_api/'

const getUserData = async () => {
    try { // f*ck around
        const [{ profileImage }, user] = await Promise.all([
            getJSON(`${API_URL}account-info-server/profileimage`),
            getJSON(`${API_URL}my-account-services/user`)
        ])
        return { sucess: true, profileImage, ...user }

    } catch (error) { // find out
        return { sucess: false }
    }
}

const getSignInLink = (isStudio) => {
    const url = new URL('https://users.wix.com/signin')
    url.searchParams.append('studio', (isStudio)? 'true' : 'false')
    url.searchParams.append('referralInfo', 'ecom_header_log_in')
    url.searchParams.append('loginCompName', 'ecom_header_log_in')
	const postSignUp = (isStudio)?
		'https://www.wix.com/intro/studio?ref=studio_signup' :
		'https://www.wix.com/new/intro'
    url.searchParams.append('postSignUp', postSignUp)
	const postLogin = (isStudio)?
		'https://www.wix.com/intro/studio?ref=studio_login' :
		'https://wix.com/my-account/sites'
    url.searchParams.append('postLogin', postLogin)
    url.searchParams.append('loginDialogContext', 'login')
    url.searchParams.append('originUrl', wixLocationFrontend.url)
    return url.href
}

const getSignOuLink = () => {
    const url = new URL('https://www.wix.com/signout')
    url.searchParams.append('redirectTo', wixLocationFrontend.url)
    return url.href
}